export var EUserRole;
(function (EUserRole) {
    EUserRole["INVESTOR"] = "Investor";
    EUserRole["SUPER_ADMIN"] = "Super Admin";
    EUserRole["DEVELOPER"] = "Developer";
})(EUserRole || (EUserRole = {}));
;
